export default __webpack_public_path__ + "static/media/2020-MC.43e1c1a3.jpg";